export const tieredmenu = {
  root: {
    class: [
      'tw-text-[16px] tw-font-sans tw-font-normal tw-text-black',

      // Shape
      'tw-rounded-md',

      // Size
      'tw-min-w-[12rem]',
      'tw-p-1',

      // Colors
      'tw-border tw-border-surface-200',

      'tw-z-overlay',
    ],
  },
  rootList: {
    class: [
      // Spacings and Shape
      'tw-list-none',
      'tw-flex tw-flex-col',
      'tw-m-0 tw-p-0',
      'tw-outline-none',
      'tw-rounded-md',
      'tw-shadow',
    ],
  },
  item: {
    class: 'tw-relative tw-my-[2px] [&:first-child]:tw-mt-0',
  },
  itemContent: ({ context }: Record<string, any>) => ({
    class: [
      // Shape
      'tw-rounded-[4px]',

      // Colors
      {
        'tw-bg-highlight tw-text-highlight-contrast':
          (context.focused && context.active) ||
          context.active ||
          (!context.focused && context.active),
      },

      // Transitions
      'tw-transition-shadow',
      'tw-duration-200',

      // States
      {
        'hover:tw-bg-grey-100': !context.active,
        'hover:tw-bg-highlight-emphasis': context.active,
      },

      // Disabled
      { 'tw-opacity-60 tw-pointer-events-none tw-cursor-default': context.disabled },
    ],
  }),
  itemLink: {
    class: [
      'tw-relative',
      // Flexbox

      'tw-flex',
      'tw-items-center',

      // Spacing
      'tw-py-2',
      'tw-px-3',

      // Misc
      'tw-no-underline',
      'tw-overflow-hidden',
      'tw-cursor-pointer',
      'tw-select-none',
      'tw-text-black',
    ],
  },
  itemIcon: {
    class: [
      // Spacing
      'tw-mr-2',
    ],
  },
  itemLabel: {
    class: ['tw-leading-none'],
  },
  submenuIcon: {
    class: [
      // Position
      'tw-ml-auto',
    ],
  },
  submenu: {
    class: [
      // Spacing
      'tw-flex tw-flex-col',
      'tw-m-0',
      'tw-p-1',
      'tw-list-none',
      'tw-min-w-[12.5rem]',

      // Shape
      'tw-shadow-none sm:tw-shadow-md',
      'tw-border tw-border-surface-200',

      // Position
      'tw-static sm:tw-absolute',
      'tw-z-10',
    ],
  },
  separator: {
    class: 'tw-border-t tw-border-surface-200',
  },
  transition: {
    enterFromClass: 'tw-opacity-0',
    enterActiveClass: 'tw-transition-opacity tw-duration-250',
  },
};
